
























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import EditableText from "@/modules/plushie/components/EditableText.vue";

import dataStore from "@/store";
import { Dictionary } from "@/lib/Dictionary.type";

import { FactoryInvoiceTypeValue } from "../../factory-invoice-type.value";
import FactoryInvoiceStore from "../../store/index";
import FactoryInvoice from "../../factory-invoice.model";
import InvoiceItem from "../../invoice-item.model";
import { InvoiceElementTypeValue } from "../../invoice-item-element-type.value";

interface SummaryElement {
  id: string;
  name: string;
  qty: number;
}

interface SummaryGroup extends SummaryElement {
  addons: SummaryElement[];
}

interface SummaryGroupAccumulator extends SummaryElement {
  hasPricedProduct: boolean;
  addons: Dictionary<SummaryElement>;
}

@Component({
  components: {
    EditableText,
  },
})
export default class FactoryInvoiceViewSummary extends Vue {
  @Prop({ required: true })
  public readonly invoiceId!: string;

  @Prop({ required: true })
  public readonly isFactoryMode!: boolean;

  @Prop({ default: false })
  public readonly isBatchScope!: boolean;

  @Prop()
  public readonly shippingAmount?: number;

  @Prop({ default: false })
  public readonly canEditShipping!: boolean;

  private fFactoryInvoiceStore: FactoryInvoiceStore;

  get isDepositInvoice(): boolean {
    return this.invoice?.type === FactoryInvoiceTypeValue.DEPOSIT;
  }

  get costOfGoodsTotal(): number | undefined {
    return this.invoice?.costOfGoodsTotal;
  }

  get designServicesTotal(): number | undefined {
    return this.invoice?.designServicesTotal;
  }

  get invoice(): FactoryInvoice | undefined {
    return this.fFactoryInvoiceStore.getFactoryInvoiceById(this.invoiceId);
  }

  get items(): InvoiceItem[] {
    return this.fFactoryInvoiceStore.getInvoiceItemsByInvoiceId(this.invoiceId);
  }

  get summaryGroups(): SummaryGroup[] {
    const groups: Dictionary<SummaryGroupAccumulator> = {};
    const compare = (a: SummaryElement, b: SummaryElement): number => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA !== nameB) {
        return nameA > nameB ? 1 : -1;
      }

      return a.id === b.id ? 0 : a.id > b.id ? 1 : -1;
    };

    this.items.forEach((item) => {
      const elements = this.fFactoryInvoiceStore.getInvoiceItemElementsByItemId(
        item.id
      );
      const product = elements.find(
        (element) => element.type === InvoiceElementTypeValue.PRODUCT
      );

      if (!product) {
        return;
      }

      if (!groups[product.entity]) {
        groups[product.entity] = {
          id: product.entity,
          name: product.name,
          qty: 0,
          hasPricedProduct: false,
          addons: {},
        };
      }

      const group = groups[product.entity];
      group.qty += product.qty;
      group.hasPricedProduct = group.hasPricedProduct || product.price !== 0;

      for (const element of elements) {
        if (
          element.type === InvoiceElementTypeValue.PRODUCT ||
          (this.isFactoryMode && element.price === 0)
        ) {
          continue;
        }

        if (!group.addons[element.entity]) {
          group.addons[element.entity] = {
            id: element.entity,
            name: element.name,
            qty: 0,
          };
        }

        group.addons[element.entity].qty += element.qty;
      }
    });

    const result: SummaryGroup[] = [];

    for (const group of Object.values(groups)) {
      const addons = Object.values(group.addons);

      if (this.isFactoryMode && !group.hasPricedProduct && !addons.length) {
        continue;
      }

      addons.sort(compare);

      result.push({
        id: group.id,
        name: group.name,
        qty: group.qty,
        addons,
      });
    }

    return result.sort(compare);
  }

  constructor() {
    super();

    this.fFactoryInvoiceStore = getModule(FactoryInvoiceStore, dataStore);
  }

  public async saveShippingAmount(
    shippingAmount: string | number
  ): Promise<void> {
    await this.fFactoryInvoiceStore.saveShippingAmount({
      invoiceId: this.invoiceId,
      shippingAmount: Number(shippingAmount),
    });
  }
}
